module.exports = __webpack_public_path__ + "static/media/prescription Drugs.36f95e59.svg";